import $ from 'jquery';
import Subscribe from '@shopify/marketing-assets/dist/javascripts/modules/subscribe';
import {setIsSubscribed} from '../utilities/subscription-cookie';

function initializeSubscriptionWithCookie() {
  const $subscriptionForm = $('.js-subscribe-with-cookie');

  $subscriptionForm.each((i, el) => {
    // eslint-disable-next-line no-unused-vars
    const subscription = new Subscribe($(el), {
      onSuccess: () => {
        setIsSubscribed(true);
      },
    });
  });
}

export default initializeSubscriptionWithCookie;
